/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {CTCEntity, GenericObject} from '@ion/core/src/types/entities';

export interface BulkEditorType extends GenericObject {
  items: CTCEntity[];
  augmentor?: CTCEntity[];
}

/**
 * @getEditedItems
 *
 * Util which helps in updating the edited props within the selected items on bulk edit ...
 *
 * ```typescript
 *
 *   import {getEditedItems} from '@ion/dls/src/utils/';
 *
 *   const result = getEditedItems([{id:}], [1,2,3,4,5,6]);
 *   // '4/6'
 *
 *   const result = partialStatusMessageFormatter([], [1,2,3,4,5,6]);
 *   // 'No'
 *
 *   const result = partialStatusMessageFormatter([1,2,3,4], [1,2,3,4,5], 'in');
 *   // '4 in 5'
 *
 * ```
 *
 */
export const getEditedItems = (
  editedVal: BulkEditorType,
  augmentItems?: (editedVal: BulkEditorType, item: CTCEntity, augmentor: CTCEntity[]) => unknown
): CTCEntity[] => {
  const {items, augmentor} = editedVal;
  delete editedVal.items;
  augmentItems && delete editedVal.augmentor;
  const val = items?.map((item: CTCEntity) => augmentItems
    ? augmentItems(editedVal, item, augmentor) : ({...item, ...editedVal}));
  return val;
};
